module.exports = __webpack_public_path__ + "static/media/logo.dfe71fd8.svg";